export { default } from './SlidingTabs';
